import styled from 'styled-components';

import {
  ThemeProps as Prop, Components, FontSize, FontFamily,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.DOR_TRAFFIC_SIGNS;

export const StyledTrafficSign = styled.div``;

export const TrafficSignTitle = styled.h4`
  /* ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG10, undefined, undefined, Components.WYSIWYG, 'header4')};
  color: ${({ $colorProfile }) => themeUtil(Prop.HEADER, CPNT, $colorProfile)}; */
  margin-bottom: 5px;
`;
